/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_TitleInputs */

const en_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrape router`)
};

const zh_hans1_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抓取路由`)
};

const pt_br2_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roteador de scraping`)
};

const es_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrutador de scraping`)
};

const fr_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routeur de scraping`)
};

const de_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraping-Router`)
};

const ru_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маршрутизатор скрапинга`)
};

const it_scrape_router_title = /** @type {(inputs: Scrape_Router_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Router di scraping`)
};

/**
* | output |
* | --- |
* | "Scrape router" |
*
* @param {Scrape_Router_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_title = /** @type {((inputs?: Scrape_Router_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_title(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_title(inputs)
	if (locale === "es") return es_scrape_router_title(inputs)
	if (locale === "fr") return fr_scrape_router_title(inputs)
	if (locale === "de") return de_scrape_router_title(inputs)
	if (locale === "ru") return ru_scrape_router_title(inputs)
	if (locale === "it") return it_scrape_router_title(inputs)
	return en_scrape_router_title(inputs)
});